// extracted by mini-css-extract-plugin
export default {"container":"quiz_answer-list_container__1bAv9"};